import TimelineItem from "./TimeLine";

export const ApplicationsSection = (props: any) => {
  return (
    <section className="relative py-24 bg-gray-100 overflow-hidden">

      {/* --- Subtle Background Grid --- */}
      <div className="absolute inset-0 opacity-[0.04]">
        <svg width="100%" height="100%">
          <defs>
            <pattern id="lightGrid" width="60" height="60" patternUnits="userSpaceOnUse">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="gray" strokeWidth="0.6" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#lightGrid)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        
        {/* --- Heading --- */}
        <div className="text-center mb-20">
          <p className="text-xs tracking-[3px] uppercase text-red-600 font-semibold mb-2">
            {props.title}
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            {props.subTitle}
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 mt-4 text-lg">
            Explore the key applications where our engineered glovebox 
            systems deliver unmatched performance and control.
          </p>
        </div>

        {/* --- Timeline Vertical Line (Center) --- */}
        <div className="absolute left-1/2 -translate-x-1/2 top-48 bottom-20 hidden md:block">
          <div className="w-[3px] h-full bg-gray-300 rounded-full relative">
            <div className="absolute inset-0 bg-gradient-to-b from-red-500/40 to-transparent animate-pulse rounded-full"></div>
          </div>
        </div>

        {/* --- Timeline Items --- */}
        <div className="flex flex-col gap-32">
          {props.applicationList.map((item: any, index: number) => (
            <TimelineItem key={index} item={item} index={index} />
          ))}
        </div>

      </div>
    </section>
  );
};
